/**
 * Is this page shown in a frame on another site? The browser lets a page
 * read the address of the page around it only when both are the same site,
 * so a frame on Tadpole's own pages is allowed and any other reads as
 * framed.
 */
export function framedByAnotherSite(): boolean {
  if (window.self === window.top) return false;
  try {
    return !window.top?.location.href;
  } catch {
    return true;
  }
}
